const style = (theme) => {
  const output = {
    root: {
      minHeight: '100%',
      paddingTop: (props) => (props.headerHeight + 80),
      color: theme.colors[2],
      background: theme.colors[11],
    },
    page: {
      position: 'relative',
      zIndex: 10,
      overflow: 'hidden',
    },
    listIntro: {
      extend: theme.wrapper,
      position: 'relative',
      zIndex: 1,
      marginBottom: 30,
      '& h1': {
        textTransform: 'uppercase',
        margin: 0,
        fontSize: 'calc(52px + 6vw)',
        color: theme.colors[1],
        fontFamily: theme.fonts[1],
        lineHeight: '0.9',
      },
    },
    list: {
      extend: theme.wrapper,
      marginBottom: 150,
      '& .ListElement__border': {
        background: theme.getRgba(theme.colors[2], 0.12),
      },
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    listIntro: {
      '& h1': {
        fontSize: 'calc(45px + 4vw)',
      },
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    listIntro: {
      '& h1': {
        paddingTop: 20,
        fontSize: 'calc(30px + 4vw)',
      },
    },
  }

  return output
}

export default style
